"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalTieValidator = exports.SignalTieIssueSeverity = exports.SignalTieIssueKind = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const signal_tie_types_1 = require("./signal-tie-types");
var SignalTieIssueKind;
(function (SignalTieIssueKind) {
    SignalTieIssueKind["DanglingTarget"] = "dangling_target";
    SignalTieIssueKind["SelfTarget"] = "self_target";
    SignalTieIssueKind["MissingPolarity"] = "missing_polarity";
    SignalTieIssueKind["ImplausibleValue"] = "implausible_value";
})(SignalTieIssueKind || (exports.SignalTieIssueKind = SignalTieIssueKind = {}));
var SignalTieIssueSeverity;
(function (SignalTieIssueSeverity) {
    SignalTieIssueSeverity["Error"] = "error";
    SignalTieIssueSeverity["Warning"] = "warning";
})(SignalTieIssueSeverity || (exports.SignalTieIssueSeverity = SignalTieIssueSeverity = {}));
class SignalTieValidator {
    static { this.PLAUSIBLE_VALUE_RANGES = {
        [signal_tie_types_1.SignalTieComponentType.Capacitor]: { min: 0.1e-12, max: 0.1 },
        [signal_tie_types_1.SignalTieComponentType.CapacitorPolarized]: { min: 1e-9, max: 100 },
        [signal_tie_types_1.SignalTieComponentType.Inductor]: { min: 1e-9, max: 10 },
        [signal_tie_types_1.SignalTieComponentType.Resistor]: { min: 0, max: 1e9 },
    }; }
    static validateTie(tie, carrierSignalId, signalIds) {
        const issues = [];
        if (tie.toSignalId === carrierSignalId) {
            issues.push({
                kind: SignalTieIssueKind.SelfTarget,
                severity: SignalTieIssueSeverity.Error,
                message: 'Tied to its own signal.',
            });
        }
        if (tie.toSignalId !== '' && !signalIds.has(tie.toSignalId)) {
            issues.push({
                kind: SignalTieIssueKind.DanglingTarget,
                severity: SignalTieIssueSeverity.Error,
                message: 'Tied to a signal that is no longer on the package.',
            });
        }
        if (tie.connectionType !== signal_tie_types_1.SignalTieConnectionType.ThroughComponent || tie.componentType === null) {
            return issues;
        }
        if ((0, signal_tie_types_1.isPolarizedTieComponentType)(tie.componentType) && tie.polarity === undefined) {
            issues.push({
                kind: SignalTieIssueKind.MissingPolarity,
                severity: SignalTieIssueSeverity.Error,
                message: 'Polarity not set: say which signal the positive pin faces.',
            });
        }
        const implausible = SignalTieValidator.findImplausibleValue(tie.componentType, tie);
        if (implausible !== undefined) {
            const range = SignalTieValidator.PLAUSIBLE_VALUE_RANGES[tie.componentType];
            const units = signal_tie_types_1.TIE_COMPONENT_TYPE_TO_UNITS[tie.componentType].short;
            const format = (value) => `${sigma_engine_shared_1.Utils.formatNumericalSIValue(value)}${units}`;
            issues.push({
                kind: SignalTieIssueKind.ImplausibleValue,
                severity: SignalTieIssueSeverity.Warning,
                message: `${format(implausible)} is outside the usual ${format(range.min)} to ${format(range.max)}; check the units.`,
            });
        }
        return issues;
    }
    static countIssues(tiesBySignalId, signalIds) {
        let errorCount = 0;
        let warningCount = 0;
        for (const [carrierSignalId, ties] of tiesBySignalId) {
            for (const tie of ties) {
                const issues = SignalTieValidator.validateTie(tie, carrierSignalId, signalIds);
                if (issues.some((issue) => issue.severity === SignalTieIssueSeverity.Error)) {
                    errorCount++;
                }
                else if (issues.length > 0) {
                    warningCount++;
                }
            }
        }
        return { errorCount, warningCount };
    }
    static findImplausibleValue(componentType, tie) {
        const value = tie.componentValue;
        if (value === null) {
            return undefined;
        }
        const entered = value.type === 'absolute' ? [value.value] : [value.min, value.max];
        const range = SignalTieValidator.PLAUSIBLE_VALUE_RANGES[componentType];
        return entered.find((v) => v !== null && (!Number.isFinite(v) || v < range.min || v > range.max));
    }
}
exports.SignalTieValidator = SignalTieValidator;
//# sourceMappingURL=signal-tie-validation.js.map